import React from 'react';
import { Link } from 'react-router-dom';
interface LimeBandCTAProps {
  text?: string;
  linkText: string;
  href: string;
}
export const LimeBandCTA: React.FC<LimeBandCTAProps> = ({
  text,
  linkText,
  href
}) => {
  return <div className="w-full bg-lime py-6 md:py-8" data-id="element-107" data-mp="1pgbk5zajnxm8">
      <div className="container mx-auto px-4 md:px-12" data-id="element-108" data-mp="1lg1eknqnz97w">
        <div className={`flex ${text ? 'flex-col md:flex-row md:items-center md:justify-between gap-4' : 'justify-end'}`} data-id="element-109" data-mp="1lfhw95x3qitc">
          {text && <p className="font-poppins font-normal text-xl md:text-2xl text-black" data-id="element-110" data-mp="1bpyds1dawqz0">
              {text}
            </p>}
          <Link to="/contact" className="inline-flex items-center font-poppins font-normal text-base md:text-lg text-black hover:opacity-80 transition-opacity" data-id="element-111" data-mp="16rognl80ngar">
            {linkText}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-2" data-id="element-112" data-mp="xsjiig0d9oz4">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-113" data-mp="3vx2t4p9q6rar" />
            </svg>
          </Link>
        </div>
      </div>
    </div>;
};